/**
 * Mock-quiz retry screen.
 */
import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { useParams } from "react-router-dom";

import { getModuleIndexOfSection } from "utils/course";
import { useAsterController } from "context";
import { VButton, VImage } from "form";

/**
 * Prompts the learner to retry a failed quiz.
 *
 * @param {{ onRestart?: Function, onContinue?: Function }} props
 */
const QuizRetry = (props) => {

  const { totalCount, successCount, onRestartClick } = props;

  const { t } = useTranslation('common');

  const { sectionIndex } = useParams();
  const [moduleIndex, setModuleIndex] = useState(null);

  const [controller] = useAsterController();
  const { structure, themes } = controller;

  useEffect(() => {
    const moduleIdx = getModuleIndexOfSection(structure, sectionIndex);
    setModuleIndex(moduleIdx);
  }, [sectionIndex, structure]);

  return <>
    <div className="w-full">
      <div className="flex items-center flex-col shadow mt-5 p-4">
        {
          moduleIndex && <>
            <VImage src={(themes || []).find(t => t.name === `badge${moduleIndex}_url`)?.value} className="w-36 h-36" />
            <p className="font-bold fsp-18 text-muted mt-4">
              {t("Oh no! You didn't make it this time. The good news is that you've earned the badge!")}
            </p>
            <p className="text-base">
              {t('Your score')}:&nbsp;
              {successCount}&nbsp;
              {successCount > 1 ? t('correct answers and') : t('correct answer and')}
              &nbsp;
              {totalCount - successCount}&nbsp;
              {totalCount - successCount > 1 ? t('incorrect answers') : t('incorrect answer')}
            </p>
            <VButton onClick={onRestartClick} variant="contained">
              {t('Repeat the quiz')}
            </VButton>
          </>
        }
      </div>
    </div>
  </>;
};

export default QuizRetry;